import "./mcdo.scss";
import { Outlet } from 'react-router-dom';

function McdoContainer() {
  return (
    <Outlet />
  )
}

export default McdoContainer